module.exports = __webpack_public_path__ + "img/calendar-check-bluish-green.3eff22ec.svg";